import EmailIcon from "@mui/icons-material/Email";
import HomeIcon from "@mui/icons-material/Home";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

export const Data = [
  {
    type: "Email",
    data: "yuvaraj3303@gmail.com",
    url: "mailto:yuvaraj3303@gmail.com",
    icon: <EmailIcon fontSize="large" />,
  },
  {
    type: "Mobile",
    data: "+91 8431226186",
    icon: <PhoneIphoneIcon fontSize="large" />,
  },
  {
    type: "Address",
    data: "Rajajinagara, Bengaluru",
    icon: <HomeIcon fontSize="large" />,
  },
  {
    type: "GitHub",
    data: "github.com/Yuv-Rajd",
    url: "https://github.com/Yuv-Rajd",
    icon: <GitHubIcon fontSize="large" />,
  },
  {
    type: "LinkedIn",
    data: "linkedin.com/in/yuvaraja-d/",
    url: "https://www.linkedin.com/in/yuvaraja-d/",
    icon: <LinkedInIcon fontSize="large" />,
  },
];
